
<template>
    <div class="client-work-container" aria-label="Client work">
        <div class="client-work-grid">
            <div class="client-work-grid__cell" v-for="(itemData, itemIndex) in publishedItems" :key="itemIndex">
                <client-work-item :item-data="itemData"></client-work-item>
            </div>
        </div>
    </div>
</template>

<script>
import clientWorkItem from '@/components/ClientWorkItem.vue';

export default {
    props: {
        contentData: Object,
    },
    components: {
        clientWorkItem,
    },
    computed: {
        publishedItems() {
            return this.contentData.items.filter(x => x.published);
        },
    },
};
</script>

<style lang="scss">
    .client-work-grid {
        display: flex;
        flex-wrap: wrap;
        margin-top: -2rem;

        @include mq($from: sm) {
            width: calc(100% + 2rem);
        }

        @include mq($from: md) {
            width: calc(100% + 3rem);
            margin-top: -3rem;
        }

        @include mq($from: ml) {
            width: calc(100% + 5rem);
            margin-top: -5rem;
        }

        @include mq($from: lg) {
            width: calc(100% + 3rem);
            margin-top: -3rem;
        }

        @include mq($from: xl) {
            width: calc(100% + 5rem);
            margin-top: -5rem;
        }
    }

    .client-work-grid__cell {
        display: flex;
        width: 100%;
        margin: 2rem 0 0 0;

        // 2 per row, 2rem gutter
        @include mq($from: sm) {
            width: calc(50% - 2rem);
            margin: 2rem 2rem 0 0;
        }

        // 2 per row, 3rem gutter
        @include mq($from: md) {
            width: calc(50% - 3rem);
            margin: 3rem 3rem 0 0;
        }

        // 2 per row, 5rem gutter
        @include mq($from: ml) {
            width: calc(50% - 5rem);
            margin: 5rem 5rem 0 0;
        }

        // 3 per row, 3 rem gutter
        @include mq($from: lg) {
            width: calc(33.333333% - 3rem);
            margin: 3rem 3rem 0 0;
        }

        // 3 per row, 5rem gutter
        @include mq($from: xl) {
            width: calc(33.333333% - 5rem);
            margin: 5rem 5rem 0 0;
        }
    }
</style>
